import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Pipe({
    name: 'atsFileReader$',
    standalone: false
})
export class AtsFileReaderPipe implements PipeTransform {
	constructor(private readonly sanitizer: DomSanitizer) {}

	transform(file: File): Observable<string> {
		return new Observable(observer => {
			const fileReader = new FileReader();

			fileReader.onload = () => {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				observer.next(this.sanitizer.sanitize(SecurityContext.URL, fileReader.result as string)!);
				observer.complete();
			};

			fileReader.onerror = () => {
				observer.error(fileReader.error);
			};

			fileReader.readAsDataURL(file);
		});
	}
}
